import React, {useState} from 'react';
import FilterIndustry from './filter-industry';
import FilterResourceType from './filter-resource-type';
import StickyComponent from './sticky-component';
import DOMPurify from 'dompurify';

const ResourceCenterFilters = (props) => {
  const moreFilters = Drupal.t('More filters');
  const lessFilters = Drupal.t('Less filters');
  const [toggleFilters, setToggleFilters] = useState(moreFilters);

  // Reset filters and scroll to top of the app.
  const resetFilters = (e) => {
    e.preventDefault();
    props.setFilters({
      resType: '',
      industry: '',
      page: 0
    });
  }

  // Show filters on mobile.
  const showFilters = (e) => {
    e.preventDefault();
    document.querySelector('.filters').classList.toggle('filters-collapsed');
    setToggleFilters(toggleFilters === moreFilters ? lessFilters : moreFilters);
  }

  return (
    <div>

      {(props.dataFilters && Object.entries(props.dataFilters.resource_type).length > 0) && (
        <FilterResourceType resType={props.dataFilters.resource_type} selected={props.filters.resType} setFilters={props.setFilters} filters={props.filters} />
      )}

      {(props.dataFilters && Object.entries(props.dataFilters.industry).length > 0) && (
        <FilterIndustry industry={props.dataFilters.industry} checked={props.filters.industry} setFilters={props.setFilters} filters={props.filters} />
      )}

      {(props.filters.resType || props.filters.industry) && (
        <div className='reset-filters'>
          <a href="#" onClick={resetFilters}>
            {Drupal.t('Reset filters')}
          </a>
        </div>
      )}

      <div className='mobil-filter' onClick={showFilters}>
        <span>{toggleFilters}</span>
        <i className="arrow"></i>
      </div>

      <div className='other-resources' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.otherLinks) }}></div>
    </div>
  );
};

export default ResourceCenterFilters;